import { useQuery } from '@tanstack/react-query';
import { retentionAdminApi } from '../api/retentionAdminApi';
import type { PolicyListFilter } from '../types/retentionAdmin';

/**
 * GET /api/eraf/retention-admin/policies — 보존 정책 목록 (RETENTION_READ)
 * queryKey: ['retention-admin', 'list', filters]
 */
export function useRetentionPolicyList(filters: PolicyListFilter) {
  return useQuery({
    queryKey: ['retention-admin', 'list', filters],
    queryFn: () =>
      retentionAdminApi.listPolicies({
        table: filters.table || undefined,
        mode: filters.mode || undefined,
        enabled: filters.enabled !== undefined ? filters.enabled : undefined,
        keyword: filters.keyword || undefined,
        page: filters.page ?? 0,
        size: filters.size ?? 20,
        sort: filters.sort ?? 'name,asc',
      }),
    staleTime: 30_000,
  });
}
